import React from "react";
import usePermission from "utils/hooks/usePermission";
// based off: https://github.dev/francois-roget/permission-provider-demo

type Props = {
  to: string;
  fallback?: JSX.Element | string;
  loadingComponent?: JSX.Element | string;
};

// This component is meant to be used everywhere a restriction based on user permission is needed
const Restricted: React.FunctionComponent<Props> = ({ to, fallback = null, children }) => {
  const [allowed] = usePermission(to);

  // If the user has that permission, render the children
  if (allowed) {
    return <>{children}</>;
  }
  // Otherwise, render the fallback
  return <>{fallback}</>;
};

export default Restricted;
